import { NS as TABS_NS } from '../../constants';

const NS = 'isActive';
export const SET_IS_ACTIVE = `${TABS_NS}/${NS}/SET_IS_ACTIVE`;
